const projectData: Record<string, any> = {

    //drop box
      "3": {
        title: "Drop-Box Robot",
        snippet: "Tufts Robotics combat robot built in 36 hours",
        description:
          "A combat robot designed for the Tufts Robotics Team combat robot competition. Drop-Box was made during my first semester at Tufts with my team consisting of Andrew Schretzmayer, Will Lapthorn, and Jack Geraghty.",
        mainImage: "/images/DropBox/product photo.JPG",
        story: [
          {
            title: "Initial Concept & Requirements",
            content:
              "The initial concept for our robot was to make a flipper style weapon that could send the standard 4lb robots flying into the air. The robot needed to be fairly small and with our team's time limit of only 36 hours we had to think fast.",
            image: "/images/DropBox/Sketch.jpg",
          },
          {
            title: "Design & Engineering Phase",
            content:
              "Using Onshape, my team collaborated to tackle the entire design process in just a single day! The rush taught us valuable lessons about planning and avoiding last-minute design challenges. In the end the CAD was janky but got the job done.",
            image: "/images/DropBox/CAD.png",
          },
          {
            title: "Manufacturing & Assembly",
            content:
              "Manufacturing Drop-box began as soon as possible. The chassis was 3D printed, while the flipper and armor segments were made from waterjet aluminum sheet metal, bent to shape. Tight deadlines pushed us to improvise, especially with last-minute acrylic gears that ended up costing us more headaches.",
            image: "/images/DropBox/Wedge.jpg",
          },
          {
            title: "Fight Night!",
            content:
              "On competition night, Drop-box faced its challenges but held its own. Despite losing in the first round, we were thrilled it moved and flipped proving of our teamwork and problem-solving in the final hours.",
            image: "/images/DropBox/Fight.jpg",
          },
        ],
        tools: ["Onshape", "3d printing", "Robotics", "Arduino", "Water Jet", "Sheet Metal Fabrication"],
        finalImages: [
          "/images/DropBox/Front.jpg",
          "/images/DropBox/Body.jpg",
          "/images/DropBox/FightClose.jpg",
        ],
        outcome: "This project was completed during my freshman year of college. Despite a tough fight, Drop-Box taught us the value of fast prototyping, team coordination, and learning through doing. It was a memorable introduction to hands-on engineering at Tufts.",
    
      },
    
    //Lights Out
      "7": {
        title: "Lights Out",
        snippet: "Physical Lights Out arduino based game",
        description:
          "A simple yet addictive handheld game utilizing linear algebra with the goal to turn off all the lights.",
        mainImage: "/images/lights_out/LightsOutMain.JPG",
        story: [
          {
            title: "Initial Ideation",
            content:
              "Lights Out was initially sketched during my senior high school linear algebra class. The goal was to demonstrate linear algebra concepts through an engaging, hands-on device.",
            image: "/images/lights_out/initial sketch section.jpeg",
          },
          {
            title: "Mechanical Design",
            content:
              "Using Autodesk Fusion, the rough sketch was transformed into a detailed CAD model used for 3d printing and as instructions for assembly.",
            image: "/images/lights_out/lights Out CAD.jpg",
          },
          {
            title: "Manufacturing",
            content:
              "I started 3D printing the main components and wiring them based on a wiring diagram created in Wokwi. After developing and testing the code, I assembled all the parts to bring the final Lights Out device to life.",
            image: "/images/lights_out/Printing.jpg",
          },
          {
            title: "Presentation",
            content:
              "After completing the final product, I presented it to my linear algebra class, where it was met with enthusiasm. Several classmates were so impressed that they asked me to make Lights Out games for them as well.",
            image: "/images/lights_out/Lights Out Drawing.png",
          },
        ],
        tools: ["Autodesk Fusion", "Arduino", "3d Printing", "Electrical Wiring"],
        finalImages: [
          "/images/lights_out/Back.JPG",
          "/images/lights_out/Lights Out ON.jpg",
          "/images/lights_out/Scene.JPG",
          "/images/lights_out/Wiring.jpg",
        ],
        outcome: "This project was completed during my senior year of high school. This project allowed me to utilize my engineering design and manufacturing skills to create a fully capable design. The final product successfully showcased the game Lights Out in a physical and easy to understand way allowing my class to understand how linear algebra plays a part in the game."
      },
    
    // Mechanical Integrator
      "6": {
        title: "Mechanical Integrator",
        snippet: "Fully mechanical definite integral calculator",
        description:
          "A fully mechanical definite integral calculator that utilizes a constant variable gear ratio to calculate integrals.",
        mainImage: "/images/mechanical_integrator/product photo.JPG",
        story: [
          {
            title: "How it Started",
            content:
              "For my high school AP Calculus final project my friend Lucy Stenger and I wanted to create something mind blowing. In our research, we landed upon the mechanical integrator after finding inspiration in old warship machines and a fascinating youtube video by Jack Monaco.",
            image: "/images/mechanical_integrator/mechIntInspo.jpg",
          },
          {
            title: "Our New Design",
            content:
              "Using Autodesk Fusion and after many iterations a new designed was realized. The new design used 3d printed gears and dials along with a LEGO motor to make the device function.",
            image: "/images/mechanical_integrator/MechIntCAD.png",
          },
          {
            title: "Manufacturing",
            content:
              "The integrator was manufactured using a combination of 3d printing, laser cutting, LEGO, and a few more robust metal components like bearing and hex shaft.",
            image: "/images/mechanical_integrator/drawing.png",
          },
          {
            title: "Presentation",
            content:
              "Once finished, we presented the mechanical integrator to our AP Calculus class with a fully successful demo of the device. Additionally Lucy took my 3d model of the integrator and created a fantastic video demonstrating how it works. (This video can also be found on YouTube)",
            video: "/images/mechanical_integrator/Luke-Joe-Mechanical-Integrator-Video.mp4",
          },
        ],
        tools: ["Autodesk Fusion", "3d Printing", "Laser Cutting","LEGO"],
        finalImages: [
          "/images/mechanical_integrator/outside.png",
          "/images/mechanical_integrator/hand photo.JPG",
          "/images/mechanical_integrator/back.png",
        ],
        outcome: "This project was completed in my junior year of high school and as such is one of my first engineering challenges that I have taken on. The mechanical integrator taught me everything from assembly design to how to deal with tolerance issues. Because of all I learned from this project, the mechanical integrator holds a special spot in my portfolio of projects."
      },
    
    //MouseMorphia
      "8": {
        title: "MouseMorphia",
        snippet: "Affordable adaptive mouse for disabled individuals",
        description:
          "Repurposing old computer mice into assistive devices to seamlessly control modern computers in daily tasks and digital work.",
        mainImage: "/images/MouseMorphia/product photo.JPG",
        story: [
          {
            title: "Sketching",
            content:
              "Initial sketches of the adaptive mouse were drawn to thoroughly understand and plan its desired layout and functions. These early drawings laid the groundwork for the design and development process.",
            image: "/images/MouseMorphia/MouseMorphia_Top_sketch.png",
          },
          {
            title: "Parametric Modeling",
            content:
              "Using Autodesk Fusion, the sketches were transformed into a fully parametric 3D model. This detailed digital model is designed for easy adjustment and will be used for the manufacturing process.",
            image: "/images/MouseMorphia/MouseMorphia Drawing with Labels.png",
          },
          {
            title: "Manufacturing and Prototyping",
            content:
              "By iterating between the 3D model and physical 3D prints, I rapidly prototyped and manufactured both an adaptive mouse and an adaptive mouse button. The main mouse base features a custom mono-jack, allowing users to connect off-the-shelf adaptive devices with MouseMorphia.",
            image: "/images/MouseMorphia/Breadboard.jpg",
          },
          {
            title: "Marketing",
            content:
              "After completing the MouseMorphia hardware, I designed a logo and developed a business idea that would enable users to buy kits and create their own MouseMorphia for a fifth of the price of other adaptive mouses.",
            image: "/images/MouseMorphia/MouseMorphia_Mouse_Box.png",
          },
          {
            title: "Award Winning",
            content:
              "After submitting MouseMorphia to Autodesk Instructables, MouseMorphia Won the Judges Prize in the Autodesk First Time Author Competition.",
            image: "/images/MouseMorphia/instructables_logo.png",
            button: {
              text: "View Instructable",
              url: "https://www.instructables.com/MouseMorphia-Adaptive-Mouse-for-Handicapped-Indivi/",
              external: true,
            },
          },
        ],
        tools: ["Autodesk Fusion", "3d Printing", "Electrical Wiring", "Autodesk Instructables"],
        finalImages: [
          "/images/MouseMorphia/MouseMorphia_logo.png",
          "/images/MouseMorphia/baseWiring.jpg",
          "/images/MouseMorphia/button sketch.png",
          "/images/MouseMorphia/Button wiring.jpg",
        ],
        outcome: "This project was completed during my senior year of high school. MouseMorphia taught me how to merge empathy-driven design with rapid prototyping to create meaningful assistive technology. From sketching and CAD modeling to building a real business case and winning an award, this project pushed me to think like both an engineer and an innovator."
      },
    
    //Gauge Block
      "2": {
        title: "Gauge Block Display",
        snippet: "Display case for a gauge block gift",
        description:
          "A quick project to display a special gift from my high school robotics team mentor",
        mainImage: "/images/gauge_block/product photo.JPG",
        story: [
          {
            title: "The Story",
            content:
              "The precision-ground 1-inch gauge block was a gift from my high school robotics mentor following my senior year on Team Ellipse 6814. It was a token of appreciation for my dedication and leadership throughout the season. Inscribed on the block is a quote from my mentor: “All things equal, make it a round number.”",
            image: "/images/Robotics/Ellipse-Logo-SOLO.png",
          },
          {
            title: "Manufacturing",
            content:
              "In the end I made four of these display cases for the four senior leaders that recieved the gauge blocks. The blocks were manufactured on my high school's brand new Shapeoko CNC router.",
            image: "/images/gauge_block/multiple.jpeg",
          },
        ],
        tools: ["Autodesk Fusion", "CNC Router", "Laser Cutter", "CAM"],
        finalImages: [
          "/images/gauge_block/Gauge Block Bark.jpg",
          "/images/gauge_block/Gauge Block Table.jpg",
        ],
        outcome: "This quick project was completed during my senior year of high school. This project was one of my first introductions to CNC manufacturing and CAM work. The gauge block display currently sits on my bedroom shelf to remind me of everything my robotics mentor has taught me."
      },
    
    //Ti-84 KE
      "1": {
        title: "Ti-84 KE",
        snippet: "Ti-84 plus ce graphing calculator in a mechanical keyboard body",
        description:
          "A Ti-84 plus ce graphing calculator in a mechanical keyboard body. Disclaimer: This is not my own original design.",
        mainImage: "/images/ti84-KE/product photo.JPG",
        story: [
          {
            title: "Credit to the Original Designer",
            content:
              "The design of this calculator keyboard was created by Noah Kiser. My version of his design has a few tweaks to make it work better for my use. Kiser’s Github repo for the project can be found below.",
            image: "/images/ti84-KE/github.png",
            button: {
              text: "View Github",
              url: "https://github.com/NCKiser/TI-84-KE/",
              external: true,
            },
          },
          {
            title: "Custom Adjustments",
            content:
              "After having the amazing resources from Noah K. I made a few modifications including a usb-c mod and some extravagant branding on the back.",
            image: ["/images/ti84-KE/usbc back.jpeg", "/images/ti84-KE/skoobs back.jpeg"]
          },
        ],
        tools: ["Autodesk Fusion", "KiCAD" , "3d Printing", "Electrical Wiring"],
        finalImages: [
          "/images/ti84-KE/ti84ke hand.jpg",
        ],
        outcome: "This project was completed during my senior year of high school. The Ti-84 KE taught me lessons on how to work from already present designs and continuously improve on them until they fit my needs."
      },

    //Machinist Hammer
      "4": {
        title: "Machinist Hammer",
        snippet: "Custom designed machinist hammer",
        description:
          "For practice turning and milling I designed a machinist hammer as a first full project utlizing several turning and milling techniques.",
        mainImage: "/images/machinist_hammer/product photo.jpg",
        story: [
          {
            title: "Initial Design",
            content:
              "The hammer was design in Solidworks with a size that is meant to be easily set on a lathe table when turning.",
            image: "/images/machinist_hammer/Hammer CAD model.png",
          },
          {
            title: "Machining",
            content:
              "I used both a manual lathe and mill to create each part of the hammer. The main body and head are made of aluminum and the head tips are made of brass and PLA.",
            image: ["/images/machinist_hammer/handle turning.jpg", "/images/machinist_hammer/In progress handle.jpg", "/images/machinist_hammer/head in progress close.jpg"]
          },
          {
            title: "Final Product",
            content:
              "The final product came out beautifully and will be actively used as a machinist hammer for my future projects!",
            image: "/images/machinist_hammer/finished hammer laying down.jpg"
          },
        ],
        tools: ["Solidworks", "Turning", "Milling"],
        finalImages: [
          "/images/machinist_hammer/Handle Drawing.JPG",
          "/images/machinist_hammer/Head Drawing.JPG",
          "/images/machinist_hammer/Head Cap Drawing.JPG",
          "/images/machinist_hammer/Finished Handle.jpg",
        ],
        outcome: "This project was completed during my sophomore year of college. This machinist hammer was one of my first projects made on a manual lathe and mill. "
      },

    //Impact Attenuator
      "5": {
      title: "Impact Attenuator",
      snippet: "Conducted isolated impact tests on the Tufts Electric Racing Team's racecar",
      description:
        "As a freshman and project lead on the Tufts Electric Racing Team, I was tasked with testing and validating an impact attenuator design for the racecar.",
      mainImage: "/images/impact_attenuator/First IA.jpg",
      story: [
        {
          title: "Background",
          content:
            "The impact attenuator is a front mounted aluminum honeycomb structure built to absorb energy in the event of a frontal crash. This project focuses on the testing of the impact attenuator and the manufacturing of an impact attenuator testing stool that models the front of the racecar.",
          image: "/images/impact_attenuator/Final on car.jpg",
          button: {
            text: "Download Design Report",
            url: "/files/Design of Impact Attenuator - Spring 2025.pdf",
            external: true,
          },
        },
        {
          title: "Research & FEA",
          content:
            "Using Solidworks FEA, I analyzed the impact attenuator to see if the previous design of the front of the car was strong enough to withstand the required forces. The FEA results showed that the car front needed a geometry redesign to be considered safe to race.",
          image: "/images/impact_attenuator/FEA.png",
        },
        {
          title: "Manufacturing & Welding",
          content:
            "In order to test the impact attenuator and prove its safety a testing stool that models the exact front of the car needed to be manufactured. Making the stool required me to learn MIG welding which I picked up fast and became a co-lead of welding on the team!",
          image: "/images/impact_attenuator/IA Welding.jpg",
        },
        {
          title: "Dynamic Load Testing",
          content:
            "Testing of the impact attenuator was done in a jerry-rigged setup as the Instron currently available at Tufts was unable to reach the required force needed to satisfy the rules of the competition. In the end the newly designed stool withstood the forces needed without plastically deforming past the limit.",
          image: "/images/impact_attenuator/IA Testing.jpg",
        },
        {
          title: "Final Product",
          content:
            "After all required changes were made to the car front, the impact attenuator was mounted to the car with epoxy and used in competition!",
          image: "/images/impact_attenuator/Mounting to car.jpg",
        },
      ],
      tools: ["Welding", "Solidworks FEA", "Instron dynamic load testing", "Onshape"],
      finalImages: [
        "/images/impact_attenuator/IA Welding Portrait.jpg",
        "/images/impact_attenuator/First Weld.jpg",
        "/images/impact_attenuator/Failed Bend Visual.jpg",
        "/images/impact_attenuator/IA Welding Jig.jpg",
      ],
      outcome: "This project was the first project I lead as the only freshman mechanical project lead on the Tufts Electric Racing Team. The impact attenuator is still being used on the team's old car. I have since moved on to other projects on the team!",
  
    },

    //Accumulator
     "11": {
      title: "Accumulator",
      inProgress: true,
      snippet: "Custom designed accumulator for the Tufts Electric Racing Team's new car",
      description:
        "The accumulator is a fully custom designed energy storage system built for Tufts Electric Racing's new car. The accumulator houses the high-voltage battery modules that provide power to the drivetrain.",
      mainImage: "/images/Accumulator/Accumulator Place Holder.png",
      story: [
        {
          title: "In progress!",
          content:
            "The accumulator is currently in progress. I am currently at the very beginning stages of the design process. Stay tuned for updates!",
          image: "/images/Accumulator/In Progress.jpg",
        },
      ],
      tools: ["Onshape", "3d printing", "Mass Production"],
      finalImages: [

      ],
      outcome: "This project is currently in progress. Stay tuned for updates!",
  
    },

    //Scissors
    "9": {
      title: "Heavy Duty Scissors",
      snippet: "Heavy duty scissors designed for my ME10 class final project",
      description:  
        "For our Materials & Manufacturing class (ME10) final project at Tufts University, our team set out to design and build a pair of heavy-duty shears capable of cutting materials such as Kevlar and carbon-fiber.",
      teamMembers: [
        "Alec Benton",
        "TJ Iannelli",
        "Joe Skubic",
        "Nick Yeung",
      ],
      mainImage: "/images/Scissors/hand open.JPG",
      story: [
        {
          title: "Project and Learning Goal",
          content:
            "Our team's goal was to design and build a pair of industrial grade scissors that that not only looked the part but also functioned. Our learning goal was to design and fabricate a product, professional shears, from scratch utilizing the skills and knowledge we learned from the ME10 class and lab in order to learn what it takes to design and fabricate a product from scratch.",
          image: "/images/Scissors/Stabbed.JPG",
        },
        {
          title: "Initial Design",
          content:
            "The scissors were designed in Solidworks based on industrial composite cutting scissors. Manufacturing processes and material selection was considered at this stage to ensure feasibility of our goal. Our processes included waterjetting the blanks, milling the blades, turning the bolt, and injection molding the handles.",
          image: "/images/Scissors/CAD Scissors.JPG",
        },
        {
          title: "Prototyping",
          content:
            "An initial prototype was made out of acrylic to test the geometry of the scissors. In this phase adjustments were made to the shape of the scissors to ease up the manufacturing process later on.",
          image: "/images/Scissors/Acrylic Prototype.JPG",
        },
        {
          title: "Waterjet Cutting and Milling",
          content:
            "The scissor blanks were waterjet from 1/4\" 6061 aluminum sheet and blades milled on a manual Bridgeport mill. We struggled with mill work holding and attempted two different methods to hold the workpiece in place: one was a 3d printed soft jaw, the other a fixture plate with bolts. In the end both setups had issues and if we were to do this again would most likely refine the fixture plate idea.",
          image: ["/images/Scissors/Waterjet.JPG", "/images/Scissors/Milling1.JPG", "/images/Scissors/Milling2.JPG"],
        },
        {
          title: "Bolt Turning",
          content:
            "The bolt was turned on a manual lathe and used an inventive technique to acheive the small threads. A 10-32 bolt was cut and threaded into the male side of the bolt avoiding the need to use a die or single point threading on such a short part.",
          image: ["/images/Scissors/Bolt.JPG", "/images/Scissors/Turning1.JPG"],
        },
        {
          title: "Injection Mold Manufacturing",
          content:
            "We intially created the molds out of Markforged Onyx 3D Printer filament interested to see if it could handle the stresses of injection molding. In the end it could not, so we pivoted to a CNC Milled mold design which was machined on a HAAS Mini Mill.",
          image: ["/images/Scissors/Molds.JPG", "/images/Scissors/3d printed mold.JPG", "/images/Scissors/Straight Handle CNC.JPG"],
        },
        {
          title: "Injection Molding",
          content:
            "We used polypropelene to inject softer handles around the scissors which also gives them a professional and finished look.",
          image: ["/images/Scissors/Injection Mold 1.JPG", "/images/Scissors/Injection Mold 2.JPG"],
        },
        {
          title: "Final Product",
          content:
            "Our final product meets our goals for this project. We are left with a professional looking and feeling pair of scissors that can actually cut!",
          image: "/images/Scissors/Final1.JPG",
        },
        {
          title: "Challenges and Learnings",
          content:
            "In making the scissors several challenges and subsequent learning opportunites appeared. Our biggest challenges were mill work holding, injection molding stresses, and blade bending. In particular the injection molding forces were much higher than we expected and even stripped a clamping bolt that was threaded into aluminum! (see top image)",
          image: ["/images/Scissors/Stripped Thread.JPG", "/images/Scissors/Failed Mold.JPG"],
        },
      ],
      tools: ["Solidworks", "Waterjet", "CNC Milling", "Manual Milling", "Turning", "Injection Molding"],
      finalImages: [
        "/images/Scissors/Cutting Fabric1.JPG",
        "/images/Scissors/Final1.JPG",
        "/images/Scissors/Final2.JPG",
        "/images/Scissors/Edge.JPG",
        "/images/Scissors/Alec stabbed.JPG",
      ],
      outcome: "We are all extremely happy with the final scissors we made for our ME10 Final Project. However, as all products are, our shears were made with limiting time constraints and there are improvements we wish we could have made. First, ideally the scissors would have been made out of a harder material than aluminum that could hold a better edge. Second, the injection molding still was not 100% perfect which we believe we could have fixed with an updated handle geometry."
    },

    //Fiberglass Laminate Testing
    "10": {
      title: "Fiberglass Laminate Testing",
      snippet: "Created, tested, and simulated fiberglass composite laminates for ME116 class",
      description:
        "For a first project in my ME116 composites class my group manufactured fiberglass test samples and then conducted Ansys APDL FEA and Instron testing to test our manufacturing process.",
      mainImage: "/images/fiberglass/post_test_samples_cropped.jpg",
      story: [
        {
          pdf: "/files/Fiberglass Prez.pdf",
          pdfExpandLabel: "View Presentation",
          pdfCollapseLabel: "Hide Presentation",
        },
        {
          title: "Final Report",
         
          button: {
            text: "Download Report",
            url: "/files/ME116 - Project 1 Final Report.pdf",
            external: true,
          },
        },
      ],
      tools: ["Composite Manufacturing", "Vacuum Bagging", "Ansys APDL", "Stress-strain Analysis","Instron Load Testing"],
      finalImages: [
        "/images/fiberglass/instron_test.jpg",
        "/images/fiberglass/post_test_samples.jpg",
      ],
      outcome: "This project gave me experience with the complete composites engineering workflow, from raw material preparation through physical validation. I gained hands-on experience with vacuum bagging, wet layups, resin mixing, waterjet sample preparation, Instron tensile testing, stress-strain analysis, ANSYS Mechanical APDL, Classical Lamination Theory, as well as the understanding that a simulation is only as accurate as the assumptions made.",
    },

    //Carbon Fiber Rear Wing
    "12": {
      title: "Carbon Fiber Rear Wing",
      snippet: "Carbon fiber rear wing designed for the Tufts Electric Racing Team's new car",
      description:
        "Carbon fiber rear wing designed in graduate level composites course (ME116) for the Tufts Electric Racing Team.",
      mainImage: "/images/Rear Wing/Full Finished Wing.jpeg",
      story: [
        {
          pdf: "/files/ME116 Final Presentation.pptx.pdf",
          pdfExpandLabel: "View Presentation",
          pdfCollapseLabel: "Hide Presentation",
        },
        {
          title: "Final Report",
         
          button: {
            text: "Download Report",
            url: "/files/Joe Skubic - ME116 Rear Wing Report.pdf",
            external: true,
          },
        },
      ],
      tools: ["Composite Manufacturing", "Vacuum Bagging", "Ansys APDL"],
      finalImages: [
        "/images/Rear Wing/Both Wing Elements Done.jpeg",
        "/images/Rear Wing/First Assembly.jpeg",
        "/images/Rear Wing/Large Wing Element Layup.jpeg",
        "/images/Rear Wing/Large Wing Elements.jpeg",
        "/images/Rear Wing/Side Plate Inserts.jpeg",
        "/images/Rear Wing/Small Wing Elements.jpeg",
        "/images/Rear Wing/Wing Element End Plate.jpeg",
      ],
      outcome: "As a final project for my graduate level composites course at Tufts this rear wing demonstrated my ability to design, simulate, and manufacture a complete composite part that could withstand the loads of a racecar. I gained expirience with the full end to end composite design and manufacturing workflow including understanding ANSYS APDL and classical lamination theory to create a simulation model of the rear wing.",
    },

    };

    export default projectData;